<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12">
        <el-form-item label="安全名称" prop="name">
          <el-select v-fixZoom v-model="nametype" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="changeName">
            <el-option v-for="item in nameArr" :key="item.index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="活动时间" prop="eventtime">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.eventtime" :clearable="false"
                          type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="24" style="height: 50px" v-if="nametype === '其他'"><span style="margin-left: 60px">其他：</span><el-input style="width: 300px" v-model="addEditForm.name" placeholder="请输入其他活动名称"></el-input></el-col>
      <el-col :span="12">
        <el-form-item label="相关餐厅" prop="">
          <el-select v-fixZoom :disabled="!addEditObj.isAdd" v-model="addEditForm.restaurantid" filterable placeholder="请选择" :clearable="true" style="width:100%;">
            <el-option v-for="item in restaurants" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="活动地点" prop="location">
          <el-input v-model="addEditForm.location" placeholder="请输入活动地点"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="参与人" prop="participantArr">
      <el-tag :key="tag" v-for="tag in addEditForm.participantArr" :closable="addEditObj.isAdd" :disable-transitions="false" @close="handleClose1(tag)">
        {{tag}}
      </el-tag>
      <el-input style="width: 100px" class="input-new-tag" v-if="inputVisible" v-model="inputValue"
                ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm">
      </el-input>
      <el-button v-else class="button-new-tag" size="small" @click="showInput"> + </el-button>
    </el-form-item>
    <el-form-item label="描述" prop="">
      <el-input type="textarea" :rows="2" v-model="addEditForm.desc" placeholder="请输入描述"></el-input>
    </el-form-item>
    <el-form-item label="签到照片" prop="">
      <div>
        <el-upload class="upload-img" action="#" list-type="picture-card" accept=".png,.jpg,jpeg"
          :auto-upload="false" :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError"
          :on-change="handleChange" :limit="5"  :file-list="dialogImageUrlArray" ref="upload">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" width="800px" append-to-body>
          <div style="text-align: center">
            <img style="max-width: 100%" :src="dialogImageUrl" alt="">
          </div>
        </el-dialog>
      </div>
    </el-form-item>
    <el-form-item label="现场照片" prop="">
      <div>
        <el-upload class="upload-img" action="#" list-type="picture-card" accept=".png,.jpg,jpeg"
                   :auto-upload="false" :on-preview="handlePictureCardPreview1"
                   :on-remove="handleRemove1" :on-success="handleSuccess" :on-error="handleError"
                   :on-change="handleChange1" :limit="5" :file-list="dialogImageUrlArray1" ref="upload1">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible1" width="800px" append-to-body>
          <div style="text-align: center">
            <img style="max-width: 100%" :src="dialogImageUrl1" alt="">
          </div>
        </el-dialog>
      </div>
    </el-form-item>
    <el-form-item label="计划方案照片" prop="">
      <div>
        <el-upload class="upload-img" action="#" list-type="picture-card" accept=".png,.jpg,jpeg"
                   :auto-upload="false" :on-preview="handlePictureCardPreview2"
                   :on-remove="handleRemove2" :on-success="handleSuccess" :on-error="handleError"
                   :on-change="handleChange2" :limit="5" :file-list="dialogImageUrlArray2" ref="upload2">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible2" width="800px" append-to-body>
          <div style="text-align: center">
            <img style="max-width: 100%" :src="dialogImageUrl2" alt="">
          </div>
        </el-dialog>
      </div>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
  <el-dialog :visible.sync="addShow" v-if="addShow" width="500px"
             :show-close="true" :close-on-click-modal="false" center class="all-open" append-to-body>
    <div class="title-top-alarm">
      <span>参与人</span>
      <div class="line-title"></div>
      <div style="margin-top: 20px">
        <el-form style="margin-right: 30px" :model="addForm" :rules="addRules" ref="addForm" label-width="70px" class="demo-ruleForm">
          <el-form-item label="参与人" prop="name">
            <el-input v-model="addForm.name" placeholder="请输入参与人姓名"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="height: 50px">
        <el-row style="margin: 0 20px">
          <el-col :span="12">
            <div class="cancel-btn" @click="addShow = !addShow">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="getParticipant('addForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {uploadimage, addsafety, updatesafety} from '../../../api/yanglaoyuan'
// import {getToken} from '../../../utils/auth'

export default {
  name: 'addEditSafety',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      restaurants: [], // 餐厅
      nameArr: ['消防演习', '消防培训', '餐厅消毒', '排查隐患', '食堂安全自检', '危险源', '电气', '用火、动火', '用电防火安全', '其他'],
      nametype: '',
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() < Date.now()
        // }
      },
      inputVisible: false,
      inputValue: '',
      addEditForm: {
        id: '',
        eventtime: '',
        name: '',
        participants: '',
        participantArr: [],
        location: '',
        desc: '',
        restaurantid: '',
        eid: '',
        signpicture: '',
        livepicture: '',
        planpicture: ''
      },
      addEditRules: {
        eventtime: [
          {required: true, message: '请选择日期', trigger: 'change'}
        ],
        restaurantid: [
          {required: true, message: '请选择餐厅', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入安全名称', trigger: 'blur'}
        ],
        location: [
          {required: true, message: '请输入活动地点', trigger: 'blur'}
        ],
        participantArr: [
          {required: true, message: '请添加人员', trigger: 'blur'}
        ]
      },
      addShow: false,
      addForm: {
        name: ''
      },
      addRules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ]
      },
      // 签到照片
      dialogImageUrl: '',
      dialogImageUrlArray: [],
      hideUpload: false,
      dialogVisible: false,
      // 现场照片
      dialogImageUrl1: '',
      dialogImageUrlArray1: [],
      hideUpload1: false,
      dialogVisible1: false,
      // 计划方案
      dialogImageUrl2: '',
      dialogImageUrlArray2: [],
      hideUpload2: false,
      dialogVisible2: false
    }
  },
  created () {
    this.restaurants = this.addEditObj.restaurants
    if (this.addEditObj.isAdd) {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    } else {
      this.addEditForm.id = this.addEditObj.row.id
      this.addEditForm.eventtime = this.addEditObj.row.eventtime
      this.addEditForm.name = this.addEditObj.row.name
      if (this.nameArr.indexOf(this.addEditForm.name) === -1) {
        this.nametype = '其他'
      } else {
        this.nametype = this.addEditForm.name
      }
      this.addEditForm.location = this.addEditObj.row.location
      this.addEditForm.desc = this.addEditObj.row.desc
      this.addEditForm.restaurantid = this.addEditObj.row.restaurantid
      this.addEditForm.eid = this.addEditObj.row.eid
      this.dialogImageUrlArray = this.addEditObj.row.signpictures
      this.dialogImageUrlArray1 = this.addEditObj.row.livepictures
      this.dialogImageUrlArray2 = this.addEditObj.row.planpictures
      if (this.addEditObj.row.participants !== '') {
        this.addEditForm.participantArr = this.addEditObj.row.participants.split(',')
      }
    }
  },
  methods: {
    // 参与人
    handleClose1 (tag) {
      this.addEditForm.participantArr.splice(this.addEditForm.participantArr.indexOf(tag), 1)
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.addEditForm.participantArr.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    changeName (val) {
      if (val === '其他') {
        this.addEditForm.name = ''
      } else {
        this.addEditForm.name = val
      }
    },
    selectDishOpen () {
      this.addForm = {name: ''}
      this.addShow = true
    },
    getParticipant (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let isHave = false
          for (let i = 0; i < this.addEditForm.participantArr.length; i++) {
            if (this.addForm.name === this.addEditForm.participantArr[i].name) {
              isHave = true
              this.$message({
                message: '已有参与人。',
                type: 'warning'
              })
              return
            }
          }
          if (!isHave) {
            this.addEditForm.participantArr.push(this.addForm)
            this.addShow = false
          }
        }
      })
    },
    handleClose (tag) {
      let index = 0
      for (let i = 0; i < this.addEditForm.participantArr.length; i++) {
        if (tag.name === this.addEditForm.participantArr[i].name) {
          break
        }
        index++
      }
      this.addEditForm.participantArr.splice(index, 1)
    },
    // 上传图片
    handleSuccess (res, file, fileList) {
      this.$message.success('上传成功')
    },
    // eslint-disable-next-line handle-callback-err
    handleError (err, file, fileList) {
      this.$message.error('上传失败')
    },
    // 签到照片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < this.dialogImageUrlArray.length; i++) {
        if (this.dialogImageUrlArray[i].url === file.url) {
          this.dialogImageUrlArray.remove(this.dialogImageUrlArray[i])
        }
      }
    },
    handleChange (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadimage(file).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        this.dialogImageUrlArray.push(file)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.upload.uploadFiles = this.dialogImageUrlArray
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },
    // 现场照片
    handlePictureCardPreview1 (file) {
      this.dialogImageUrl1 = file.url
      this.dialogVisible1 = true
    },
    handleRemove1 (file, fileList) {
      for (let i = 0; i < this.dialogImageUrlArray1.length; i++) {
        if (this.dialogImageUrlArray1[i].url === file.url) {
          this.dialogImageUrlArray1.remove(this.dialogImageUrlArray1[i])
        }
      }
    },
    handleChange1 (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadimage(file).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        this.dialogImageUrlArray1.push(file)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.upload1.uploadFiles = this.dialogImageUrlArray1
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },
    // 计划方案照片
    handlePictureCardPreview2 (file) {
      this.dialogImageUrl2 = file.url
      this.dialogVisible2 = true
    },
    handleRemove2 (file, fileList) {
      for (let i = 0; i < this.dialogImageUrlArray2.length; i++) {
        if (this.dialogImageUrlArray2[i].url === file.url) {
          this.dialogImageUrlArray2.remove(this.dialogImageUrlArray2[i])
        }
      }
    },
    handleChange2 (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadimage(file).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        this.dialogImageUrlArray2.push(file)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.upload2.uploadFiles = this.dialogImageUrlArray2
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addEditForm.name === '') {
            this.$message({
              message: '请输入安全名称。',
              type: 'warning'
            })
            return
          }
          let signpicture = ''
          let livepicture = ''
          let planpicture = ''
          for (let i = 0; i < this.dialogImageUrlArray.length; i++) {
            signpicture = signpicture === '' ? this.dialogImageUrlArray[i].filename : (signpicture + ',' + this.dialogImageUrlArray[i].filename)
          }
          for (let i = 0; i < this.dialogImageUrlArray1.length; i++) {
            livepicture = livepicture === '' ? this.dialogImageUrlArray1[i].filename : (livepicture + ',' + this.dialogImageUrlArray1[i].filename)
          }
          for (let i = 0; i < this.dialogImageUrlArray2.length; i++) {
            planpicture = planpicture === '' ? this.dialogImageUrlArray2[i].filename : (planpicture + ',' + this.dialogImageUrlArray2[i].filename)
          }
          let participants = ''
          for (let i = 0; i < this.addEditForm.participantArr.length; i++) {
            participants = participants === '' ? this.addEditForm.participantArr[i] : (participants + ',' + this.addEditForm.participantArr[i])
          }
          if (this.addEditObj.isAdd) {
            let data = {
              eventtime: this.addEditForm.eventtime,
              name: this.addEditForm.name,
              participants: participants,
              location: this.addEditForm.location,
              desc: this.addEditForm.desc,
              restaurantid: this.addEditForm.restaurantid === '' ? 0 : this.addEditForm.restaurantid,
              eid: this.addEditForm.eid,
              signpicture: signpicture,
              livepicture: livepicture,
              planpicture: planpicture
            }
            addsafety(data).then(res => {
              this.$notify({title: '成功', message: '成功新增安全记录', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            let data = {
              id: this.addEditForm.id,
              eventtime: this.addEditForm.eventtime,
              name: this.addEditForm.name,
              participants: participants,
              location: this.addEditForm.location,
              desc: this.addEditForm.desc,
              restaurantid: this.addEditForm.restaurantid,
              eid: this.addEditForm.eid,
              signpicture: signpicture,
              livepicture: livepicture,
              planpicture: planpicture
            }
            updatesafety(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑安全记录', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditSafety.vue